AdView = require 'views/ads/ad-view'
templates = require 'views/internal/templates'
getExperiment = require 'lib/experiments/simple-test'

module.exports = class PopOverAdView extends AdView
  className: 'pop-over-list-ad'
  render: ->
    adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')
    if adsLayoutExperimentEnabled
      @$el.addClass('ads-layout-experiment')

    @$el.html(templates.fill('pop_over_ad', {
      copyHtml: @copyHtml()
      iconClass: @iconClass()
    }))
    @

  copyHtml: ->
    ""



// WEBPACK FOOTER //
// ./app/scripts/views/ads/pop-over-ad-view.coffee